import React from 'react';
import { useTheme } from '../../../../context/themeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import styles from './ThemeToggle.module.css';

const ThemeToggle = ({ inline = false, landing = false }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className={`${styles.toggle} ${inline ? styles.inline : ''} ${landing ? styles.landing : ''}`}
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Activar modo oscuro' : 'Activar modo claro'}
      title={theme === 'light' ? 'Modo oscuro' : 'Modo claro'}
    >
      <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
    </button>
  );
};

export default ThemeToggle;
